import React, { useState } from 'react';

import { Card, CardContent, Typography } from '@material-ui/core';
import { unCamelCase } from './../../helpers/camelCase';
import { convertBoolean } from '../../helpers/convertBoolean';
import { formatCurrency } from '../../helpers/formatCurrency';

const CardMetrics = ({ data, isClickable = false, onClickCardKeys }) => {
  const [currency, setCurrency] = useState('BRL');

  const setValue = (key, value) => {
    key = key.toLowerCase();
    if (
      key.indexOf('balance') > -1 ||
      key.indexOf('transactioned') > -1 ||
      key.indexOf('paymentsvalue') > -1 ||
      key.indexOf('totalindonations') > -1
    )
      return formatCurrency(currency, value ? value : '000');
    if (key.indexOf('percentage') > -1 || key.indexOf('rate') > -1) return value ? `${value} %` : 'No Data 🦖';
    if (key.indexOf('isactive') > -1) return value ? '✅ Yes' : '⛔️ No';
    if (key.indexOf('status') > -1) return value == 'enabled' || value == 'active' ? '✅ Yes' : '⛔️ No';
    return convertBoolean(value || 0);
  };

  return (
    <div className="card-container" data-testid="box-subscribers">
      {data &&
        Object.keys(data)
          .filter(exception => exception !== 'lastPayments')
          .map(key => (
            <Card data-testid="card-metrics" key={key} className={`card ${isClickable ? 'clickable' : ''}`}>
              <CardContent
                onClick={() => {
                  isClickable && onClickCardKeys(key);
                }}
              >
                <Typography variant="h5" component="h2">
                  {setValue(key, data[key])}
                </Typography>
                <Typography color="textSecondary">
                  {key === 'channelsThatHavePostedSomething' ? 'Channels Post Something' : unCamelCase(key)}
                </Typography>
              </CardContent>
            </Card>
          ))}
    </div>
  );
};

export default CardMetrics;
